import apiClient from './client';

export interface AuditLogEntry {
  id: string;
  action: string;
  entityType: string;
  entityId: string;
  userId: string;
  canvasId: string | null;
  changes: Record<string, unknown> | null;
  createdAt: string;
}

export const auditApi = {
  getByCanvas: async (
    canvasId: string,
    limit = 50,
    offset = 0,
  ): Promise<AuditLogEntry[]> => {
    const { data } = await apiClient.get<AuditLogEntry[]>('/audit', {
      params: { canvasId, limit, offset },
    });
    return data;
  },
};

export default auditApi;
